import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    { label: 'ホーム', href: '/' },
    { label: '問題点', href: '/#problems' },
    { label: '解決事例', href: '/#property-types' },
    { label: '料金', href: '/#pricing' },
    { label: 'コラム', href: '/blog' },
    { label: '事務所案内', href: '/#office' },
    { label: '相談予約', href: '/#contact' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <h1 className="flex flex-col">
              <span className={`font-noto text-xl lg:text-2xl font-bold tracking-wide transition-colors ${
                isScrolled ? 'text-navy-800' : 'text-white'
              }`}>
                冨田・島岡法律事務所
              </span>
              <span className={`font-en text-[10px] tracking-wider transition-colors ${
                isScrolled ? 'text-navy-600' : 'text-white/80'
              }`}>
                TOMIDA SHIMAOKA LAW OFFICE
              </span>
            </h1>
          </div>
          
          <nav className="hidden lg:flex items-center space-x-10">
            <button onClick={() => scrollToSection('problems')} className={`font-en text-sm tracking-wider transition-colors cursor-pointer ${
              isScrolled ? 'text-navy-800 hover:text-navy-600' : 'text-white hover:text-beige-200'
            }`}>
              <span className="block text-xs mb-1">PROBLEMS</span>
              <span className="block text-sm font-noto">お悩み</span>
            </button>
            <button onClick={() => scrollToSection('property-types')} className={`font-en text-sm tracking-wider transition-colors cursor-pointer ${
              isScrolled ? 'text-navy-800 hover:text-navy-600' : 'text-white hover:text-beige-200'
            }`}>
              <span className="block text-xs mb-1">SERVICE</span>
              <span className="block text-sm font-noto">処分戦略</span>
            </button>
            <button onClick={() => scrollToSection('flow')} className={`font-en text-sm tracking-wider transition-colors cursor-pointer ${
              isScrolled ? 'text-navy-800 hover:text-navy-600' : 'text-white hover:text-beige-200'
            }`}>
              <span className="block text-xs mb-1">FLOW</span>
              <span className="block text-sm font-noto">解決の流れ</span>
            </button>
            <button onClick={() => scrollToSection('price')} className={`font-en text-sm tracking-wider transition-colors cursor-pointer ${
              isScrolled ? 'text-navy-800 hover:text-navy-600' : 'text-white hover:text-beige-200'
            }`}>
              <span className="block text-xs mb-1">PRICE</span>
              <span className="block text-sm font-noto">料金</span>
            </button>
            <Link to="/blog" className={`font-en text-sm tracking-wider transition-colors cursor-pointer ${
              isScrolled ? 'text-navy-800 hover:text-navy-600' : 'text-white hover:text-beige-200'
            }`}>
              <span className="block text-xs mb-1">COLUMN</span>
              <span className="block text-sm font-noto">コラム</span>
            </Link>
            <button onClick={() => scrollToSection('introduction')} className={`font-en text-sm tracking-wider transition-colors cursor-pointer ${
              isScrolled ? 'text-navy-800 hover:text-navy-600' : 'text-white hover:text-beige-200'
            }`}>
              <span className="block text-xs mb-1">LAWYER</span>
              <span className="block text-sm font-noto">弁護士紹介</span>
            </button>
            <button onClick={() => scrollToSection('contact')} className={`font-en text-sm tracking-wider transition-colors cursor-pointer ${
              isScrolled ? 'text-navy-800 hover:text-navy-600' : 'text-white hover:text-beige-200'
            }`}>
              <span className="block text-xs mb-1">CONTACT</span>
              <span className="block text-sm font-noto">お問い合わせ</span>
            </button>
          </nav>
          
          <div className="hidden lg:flex items-center">
            <a 
              href="https://forms.gle/zPw2NXXr6K7nXgAm6"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-navy-800 text-white px-6 py-3 rounded-md hover:bg-navy-700 transition-colors font-noto text-sm whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>
              無料相談
            </a>
          </div>

          <button
            className="lg:hidden text-navy-800"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} ${!isScrolled && 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <nav className="px-6 py-4 space-y-4">
            <button onClick={() => scrollToSection('problems')} className="block text-navy-800 hover:text-navy-600 font-noto cursor-pointer w-full text-left">お悩み</button>
            <button onClick={() => scrollToSection('property-types')} className="block text-navy-800 hover:text-navy-600 font-noto cursor-pointer w-full text-left">処分戦略</button>
            <button onClick={() => scrollToSection('flow')} className="block text-navy-800 hover:text-navy-600 font-noto cursor-pointer w-full text-left">解決の流れ</button>
            <button onClick={() => scrollToSection('price')} className="block text-navy-800 hover:text-navy-600 font-noto cursor-pointer w-full text-left">料金</button>
            <Link to="/blog" className="block text-navy-800 hover:text-navy-600 font-noto cursor-pointer w-full text-left">コラム</Link>
            <button onClick={() => scrollToSection('introduction')} className="block text-navy-800 hover:text-navy-600 font-noto cursor-pointer w-full text-left">弁護士紹介</button>
            <button onClick={() => scrollToSection('contact')} className="block text-navy-800 hover:text-navy-600 font-noto cursor-pointer w-full text-left">お問い合わせ</button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
